export const viewStateActionTypes = {
  SELECT_SECTION: 'SELECT_SECTION',
  SET_FIELDS: 'SET_FIELDS',
  CLOSE_SECTION: 'CLOSE_SECTION',
  OPEN_FIELD: 'OPEN_FIELD',
  CLOSE_FIELD: 'CLOSE_FIELD',
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  OPEN_POPOVER: 'OPEN_POPOVER',
  CLOSE_POPOVER: 'CLOSE_POPOVER',
  CLEAR_BACKGROUND: ' CLEAR_BACKGROUND',
};
